import { Record } from 'immutable';
import { handleActions } from 'redux-actions';
import * as errorActions from './error-actions';
import { ERROR_MESSAGES, ERROR_TYPES } from './errors';

const cleanState = {
  errorState: false,
  errorType: null,
  errorMessage: null,
};

const initState = new Record(cleanState)();

export const errorReducer = handleActions(
  {
    // generic set error with args
    [errorActions.SET_ERROR_STATE]: (state, action) => {
      const { errorType, errorMessage } = action.payload;
      return state.merge({ errorState: true, errorType, errorMessage });
    },
    // predefined unauthorized error state
    [errorActions.SET_UNAUTHORIZED_ERROR_STATE]: (state) =>
      state.merge({
        errorState: true,
        errorType: ERROR_TYPES.UnauthorizedException,
        errorMessage: ERROR_MESSAGES.UnauthorizedException,
      }),
    // reset error state to clean state
    [errorActions.CLEAR_ERROR_STATE]: (state) => state.merge(cleanState),
  },
  initState
);
